import {useState, useRef} from 'react';
import { message } from 'antd';

const Messages = () => {
  // debugger;
  const [messageApi,messageHolder] = message.useMessage();
  const [currentMessageKey, setCurrentMessageKey] = useState(null);
  const currentMessageRef = useRef(null);
  const showMessageOnce = (content, type) => {
    console.log('showMessageOnce called with:', content, type);
    try {
      if (currentMessageKey) {
        messageApi.destroy(currentMessageKey);
        console.log('Destroyed previous message:', currentMessageKey);
      }
      const key = `open${Date.now()}`; // Unique key to avoid duplicate messages
      messageApi.config({
        top: 100,
        duration: 0.5,
        maxCount: 1,
        rtl: true,
        prefixCls: 'my-message',
      });
      const cont =  <div style={{ fontSize: "20px", fontWeight: "bold" }}>
      {content}
    </div>
      messageApi.open({
        key,
        type,
        cont,
        onClose: () => setCurrentMessageKey(null),
      });
      setCurrentMessageKey(key);
      console.log('New message set with key:', key);
    } catch (error) {
      console.error('Error in showMessageOnce:', error);
    }    
  };
  const showMessage = (message_text) => {
     // Remove all previous messages
    if (currentMessageRef.current === message_text) {
      message.destroy();
    }
    const key = `message_${Date.now()}`;
    message.info({
      key,
      content: (
        <div style={{ fontSize: "20px", fontWeight: "bold" }}>
          {message_text}
        </div>
      ),
      duration: 2, // Stays for 2 seconds
    });
    currentMessageRef.current = message_text;
    setCurrentMessageKey(key);
  };
  const showErrorMessage = (message_text) => {
    // message.destroy(); // Remove all previous messages
    if (currentMessageRef.current === message_text) {
      message.destroy();
    }
    const key = `error_${Date.now()}`;
    message.error({
      key,
      content: (
        <div style={{ fontSize: "20px", fontWeight: "bold" }}>
          {message_text}
        </div>
      ),
      duration: 2, // Stays for 2 seconds
    });
    currentMessageRef.current = message_text;
    setCurrentMessageKey(key);
  };

  const showMessageInfo = (message_text) => {
    // if (currentMessageRef.current === message_text) {
      message.destroy();
    // }
    message.info({
      content: (
        <div style={{ fontSize: "20px", fontWeight: "bold" }}>
          {message_text}
        </div>
      ),
      duration: 2, // Stays for 2 seconds
    });
  };

  const showMessageSuccess = (message_text) => {
    // if (currentMessageRef.current === message_text) {
      message.destroy();
    // }
    message.success({
      content: (
        <div style={{ fontSize: "20px", fontWeight: "bold" }}>
          {message_text}
        </div>
      ),
      duration: 2, // Stays for 2 seconds
    });
  };

  const showMessageError = (message_text) => {
    // if (currentMessageRef.current === message_text) {
      message.destroy();
    // }
    message.error({
      content: (
        <div style={{ fontSize: "20px", fontWeight: "bold" }}>
          {message_text}
        </div>
      ),
      duration: 2, // Stays for 2 seconds
    });
  };

  const showMessageWarning = (message_text) => {
    // if (currentMessageRef.current === message_text) {
      message.destroy();
    // }
    message.warning({
      content: (
        <div style={{ fontSize: "20px", fontWeight: "bold" }}>
          {message_text}
        </div>
      ),
      duration: 2, // Stays for 2 seconds
    });
  };

  return {showMessageOnce, messageHolder, showMessage, showErrorMessage, showMessageInfo, showMessageWarning, showMessageError, showMessageSuccess};
  
}
export default Messages;